import * as yup from 'yup';

import { FlightOperationNotification } from '../../core/api/clients';

import commonValidators from '../../core/validators/commonValidators';
import flightValidators from '../../core/validators/flightValidators';

type FlightOperationNotificationData = Pick<FlightOperationNotification,
'flightNumber' |
'aircraftNumber' |
'departureAirport' |
'scheduledArrivalAirport' |
'landingAirport' |
'captain' |
'firstOfficer' |
'flightAttendant' |
'dispatcher' |
'eventTitle' |
'location' |
'eventDate' |
'localEventTime' |
'eventType' |
'eventType2' |
'eventType3' |
'typeOfFlight' |
'numberOfPassengers' |
'emergencyDeclared' |
'narrative' |
'$discriminator'
>;
const FlightOperationNotificationValidationSchema: yup.ObjectSchema<FlightOperationNotificationData> = yup.object({
  $discriminator: yup.string().required().meta({ step: 0 }),
  // Flight & Crew
  flightNumber: flightValidators.flightNumber({ label: 'Flight Number', step: 0, optionalIfBlankGenerated: true }),
  aircraftNumber: flightValidators.aircraftNumber({ label: 'Aircraft Number', step: 0, required: true }),

  departureAirport: flightValidators.airport({ label: 'Departure Airport', step: 0, required: true }),
  scheduledArrivalAirport: flightValidators.airport({ label: 'Scheduled Arrival Airport', step: 0, required: true }),
  landingAirport: flightValidators.airport({ label: 'Landing Airport', step: 0, required: true }),

  captain: flightValidators.crewMember({ label: 'Captain', step: 0, optionalIfBlankGenerated: true }),
  firstOfficer: flightValidators.crewMember({ label: 'First Officer', step: 0, optionalIfBlankGenerated: true }),
  flightAttendant: flightValidators.crewMember({
    label: 'Flight Attendant',
    step: 0,
    optionalIfBlankGenerated: true,
    requiredIfRevenue: true,
  }),
  dispatcher: flightValidators.crewMember({ label: 'Dispatcher', step: 0, optionalIfBlankGenerated: true }),

  // Event
  eventTitle: commonValidators.nullableString({ label: 'Event Title', step: 1, required: true, maxLength: 75 }),
  location: commonValidators.nullableString({ label: 'Location of Event', step: 1 }),
  eventDate: commonValidators.nullableString({ label: 'Event Date', required: true, step: 1 }),

  localEventTime: commonValidators.time({
    message: 'Local Event Time must be a valid 24-hour time',
    label: 'Local Event Time',
    required: true,
    step: 1,
  }),

  eventType: commonValidators.nullableString({
    label: 'Event Type',
    required: true,
    step: 1,
  }),

  eventType2: commonValidators.nullableString({
    label: 'Event Type 2',
    required: true,
    step: 1,
  }),

  eventType3: commonValidators.nullableString({
    label: 'Event Type 3',
    required: true,
    step: 1,
  }),

  typeOfFlight: commonValidators.nullableString({
    label: 'Type of Flight',
    required: true,
    step: 1,
  }),

  numberOfPassengers: yup.number()
    .label('Number of Passengers')
    .typeError('Number of Passengers must be a number')
    .integer()
    .nullable()
    .optional()
    .meta({ step: 1 }),

  emergencyDeclared: commonValidators.radioGroupOption({ label: 'Emergency Declared', required: true, step: 1 }),

  // Narrative
  narrative: yup.string()
    .label('Narrative')
    .nullable()
    .required()
    .meta({ step: 2 }),
});

export default FlightOperationNotificationValidationSchema;
